// extracted by mini-css-extract-plugin
module.exports = {"Footer":"style-module--Footer--1Ui8G","LinksWrapper":"style-module--LinksWrapper--2oysP","TAS":"style-module--TAS--3M87v"};